import React from "react";
import {Chip, ChipProps, Tooltip} from "@mui/material";
import {useTranslation} from "react-i18next";
import {AdminI18N} from "@/translations";
import {CompanyRelationshipDto, CompanyRelationshipStatus} from "@/api/data-contracts";
import {DateFormatter} from "@/lib/components/DateFormate";
import dayjs from "dayjs";

type Props = { relationship?: CompanyRelationshipDto };

const CompanyStatusChip: React.FC<Props> = ({ relationship }) => {
    const { t } = useTranslation();
    const dateFormat = DateFormatter("date");
    let label: string;
    let color: ChipProps["color"];
    let tooltip: string | undefined;
    const currentStatus = relationship?.currentStatus;
    const desiredStatus = relationship?.desiredStatus;
    const effectiveAt = relationship?.effectiveAt;

    if (!currentStatus || currentStatus === CompanyRelationshipStatus.WHITELIST) {
        label = t(AdminI18N.companyRelationships.status.whitelist);
        color = "success";
    } else if (
        currentStatus === CompanyRelationshipStatus.BLACKLIST &&
        desiredStatus === CompanyRelationshipStatus.WHITELIST
    ) {
        // Third status: Blacklisted with pending whitelist request
        label = t(AdminI18N.companyRelationships.status.desiredWhitelist);
        color = "warning";
        if (effectiveAt) {
            tooltip = t(AdminI18N.companyRelationships.tooltip.desiredWhitelist, {
                date: dayjs(effectiveAt).format(dateFormat)
            });
        }
    } else {
        // Only blacklisted, without whitelist request
        label = t(AdminI18N.companyRelationships.status.blacklist);
        color = "error";
    }

    const chip = <Chip label={label} color={color} size="small" />;
    return tooltip ? <Tooltip title={tooltip}>{chip}</Tooltip> : chip;
};

export default CompanyStatusChip;
